// extracted by mini-css-extract-plugin
export var wrapper = "Slide-module--wrapper--60fvv";
export var content = "Slide-module--content--u27bp";
export var img = "Slide-module--img--LFxIG";
export var title = "Slide-module--title--v44sS";
export var bold = "Slide-module--bold--lkWqw";